export const typeOfServiceOptions = [
  {
    value: 'Business',
    text: 'Business',
  },
  {
    value: 'Residence',
    text: 'Residence',
  },
];

export const streetDirOptions = [
  {
    value: 'S',
    text: 'S',
  },
  {
    value: 'E',
    text: 'E',
  },
  {
    value: 'W',
    text: 'W',
  },
  {
    value: 'N',
    text: 'N',
  },
  {
    value: 'NE',
    text: 'NE',
  },
  {
    value: 'NW',
    text: 'NW',
  },
  {
    value: 'SE',
    text: 'SE',
  },
  {
    value: 'SW',
    text: 'SW',
  },
];

export const desiredPortTimeZoneOptions = [
  {
    value: 'US/Central',
    text: 'US/Central',
  },
  {
    value: 'Eastern',
    text: 'Eastern',
    disabled: true,
  },
  {
    value: 'GMT',
    text: 'GMT',
    disabled: true,
  },
  {
    value: 'Mountain',
    text: 'Mountain',
    disabled: true,
  },
  {
    value: 'Pacific',
    text: 'Pacific',
    disabled: true,
  },
];

export const orderStatusOptions = [
  {
    value: 'INCOMPLETE',
    text: 'Incomplete',
  },
  {
    value: 'PENDING',
    text: 'Pending',
  },
  {
    value: 'PENDINGCANCEL',
    text: 'Pending Cancel',
  },
  {
    value: 'CANCELED',
    text: 'Canceled',
  },
  {
    value: 'CLOSED',
    text: 'Closed',
  },
];
